<div class="topbar-item">
    <div ngbDropdown placement="bottom-right" class="dropdown">
        <button ngbDropdownToggle class="topbar-link fw-bold drop-arrow-none" [disabled]="isLoading">
            <img [src]="selectedLang.flag" [alt]="selectedLang.name" class="rounded me-2"
                 height="18"> {{ selectedLang.nativeName }}
            <span *ngIf="isLoading" class="ms-1">
                <i class="fas fa-spinner fa-spin"></i>
            </span>
        </button>
        <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end">
            <a *ngFor="let language of languages"
               class="dropdown-item"
               role="button"
               (click)="changeLanguage(language.code)"
               [class.active]="selectedLang.code === language.code"
               [attr.title]="language.name">
                <img [src]="language.flag" [alt]="language.code" class="me-1 rounded" height="18">
                <span class="align-middle">{{ language.nativeName }}</span>
            </a>
        </div>
    </div>
</div>
